import styled from 'styled-components';
import PropTypes from 'prop-types';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import React from 'react';
import { Search } from '../../../../components/Icon';
import { BaseComponent } from '../../../../components/BaseComponent';
import { changeCompanyProductsFilter } from '../../actions';

import styles from './SearchText.module.css';

const STATE = {
  search: '',
};
/* eslint-disable react/prefer-stateless-function */
class CompanyProductSearchTextComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
      search: props.filter.searchString || '',
    });
  }

  componentDidMount() {}

  reset() {
    this.setState({ ...STATE });
  }

  doSearch() {
    this.props.setSearchString(this.state.search);
  }

  handleKeyPress = event => {
    if (event.key === 'Enter') {
      this.props.setSearchString(this.state.search);
    }
  };

  searchStringChangeHandler() {
    this._t = this.timeout(
      () => {
        this.props.setSearchString(this.state.search);
      },
      600,
      this._t,
    );
  }

  render() {
    return (
      <div className="d-flex">
        <input
          type="text"
          className={`form-control fw-light ${styles.Input}`}
          name="search"
          value={this.state.search}
          placeholder={this.lblStr('search')}
          onChange={evt => {
            this.setState({ search: evt.target.value });
          }}
          onKeyPress={this.handleKeyPress}
        />
        <button className={`btn btn-outline-secondary ${styles.Button}`} type="button" onClick={this.doSearch.bind(this)}>
          <Search />
        </button>
      </div>
    );
  }
}

CompanyProductSearchTextComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    //filter: selectVehicleFilter(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    setSearchString(string) {
      dispatch(changeCompanyProductsFilter('searchString', string));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const CompanyProductSearchText = compose(withConnect, withRouter, injectIntl)(CompanyProductSearchTextComp);
